import { OutboundTripDetailPhotosDto } from 'dtos/outboundTrips'
import * as yup from 'yup'

export const OutboundTripDetailPhotosDtoValidator = yup.object<OutboundTripDetailPhotosDto>({
  driversLicensePhotoFile: yup.mixed().required(`Driver's License is required.`)
})
